import { IsEnum } from '@pristine-ts/class-validator';
import { Locale } from '@magieno/common';

export class UserLocaleUpdateOptions {
  @IsEnum(Locale)
  locale: Locale;
}
